import { Component } from '@angular/core';

@Component({
  selector: 'my-page-not-found',
  template: require('./page-not-found.component.html')
})
export class PageNotFoundComponent {

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/components/misc-components/page-not-found.component.ts
 **/